// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { getSettingsCollection } from "@west/App/Store/Selectors/SettingsSelectors";
import { mergeWithCss } from "@west/XDL/Utilities";
import React, { FC, useState } from "react";

interface OwnProps {
    extendedStyled?: UomMessageStyles;
}

type Props = OwnProps & HasProduct;

export interface UomMessageStyles {
    message?: TypographyPresentationProps;
}

export const uomMessageStyles: UomMessageStyles = {};

const UomMessage: FC<Props> = ({ product, extendedStyled }) => {
    const [styles] = useState(() => mergeWithCss(uomMessageStyles, extendedStyled));
    const productSettings = useAppSelector(state => getSettingsCollection(state).productSettings);
    const isHidden =
        !productSettings?.alternateUnitsOfMeasure ||
        !product.unitOfMeasures ||
        product.unitOfMeasures.filter(uom => uom.unitOfMeasure).length <= 1;

    if (isHidden) {
        return null;
    }

    return (
        <Typography {...styles.message} data-test-selector="Uom_Message">
            {siteMessage("Custom_product_uom_message")}
        </Typography>
    );
};

export default withProduct(UomMessage);
